import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-center text-xl" }
const _hoisted_2 = { class: "font-bold" }

import {
  swalErrNotification,
  swalNotification,
} from '@/core/helpers/utils';
import { useLoading } from '@/core/hooks/use-loading';
import { usePagination } from '@/core/hooks/use-pagination';
import { useRouterCustom } from '@/core/hooks/use-router-custom';
import { useSafeRefetch } from '@/core/hooks/use-safe-refetch';
import { usePageHeader } from '@/core/hooks/usePageHeader';
import { IBienBanGiaiTheResponseBase, IKeHoachSuaChuaResponseBase } from '@/core/interfaces/ApiResponses';
import { BienBanGiaiTheService } from '@/core/services/BienBanGiaiThe.service';
import { BIEN_BAN_GIAI_THE } from '@/core/constants/permissions';
import debounce from 'lodash/debounce';
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import ConfirmationDialog from '@/components/confirmation-dialog/ConfirmationDialog.vue';
import BienBanGiaiTheTable from '@/components/shared/bien-ban-giai-the-table/BienBanGiaiTheTable.vue';
import ConfirmHoanThanh from '@/components/shared/confirm-hoan-thanh-modal/ConfirmHoanThanh.vue';
import Pagination from '@/components/shared/pagination/Pagination.vue';
import PageContentBase from '@/layout/_shared/PageContentBase.vue';
import PageHeaderFilters from '@/layout/header/PageHeaderFilters.vue';
import FilterItem from '@/layout/_shared/FilterItem.vue';
import { KeHoachSuaChuaService } from '@/core/services/KeHoachSuaChua.service';
import DanhMucToaXeSearchInput from '@/components/shared/danh-muc-toa-xe-search-input/DanhMucToaXeSearchInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { push } = useRouterCustom();
const { startLoading, endLoading } = useLoading();
const { currentPage, totalItems, perPage } = usePagination();

const items = ref<IBienBanGiaiTheResponseBase[]>([]);
const isConfirmDeleteDialogDisplay = ref(false);
const selectedBienBanForDelete = ref<IBienBanGiaiTheResponseBase | null>(null);
const dmToaXeId = ref<number | null>(null);
const loaiBienBan = ref<number | ''>('');
const keHoachSuaChuaId = ref<number | null>(null);
const keHoachSuaChuaOptions = ref<IKeHoachSuaChuaResponseBase[]>([]);
const selectingBienBan = ref<IBienBanGiaiTheResponseBase | null>(null);
const confirmHoanThanhBienBan = ref(false);
document.title = 'Biên bản giải thể - Đường sắt Hà Nội';

const loaiBienBanOptions = [
  { label: 'Tất cả', value: '' },
  { label: 'Không theo kế hoạch', value: 0 },
  { label: 'Theo kế hoạch', value: 1 },
  { label: 'Biên bản bổ sung', value: 2 },
];

const showFilterByKeHoach = computed(() => loaiBienBan.value === 1);

const { searchQuery } = usePageHeader({
  title: 'Danh sách biên bản giải thể',
  breadcrumbs: [{ text: 'BBGT' }],
  showSearch: true,
  searchPlaceholder: 'Tìm biên bản giải thể',
  addLabel: 'Thêm BBGT',
  addPermissions: [BIEN_BAN_GIAI_THE.TAO_MOI],
  onAdd: () => push('/quan-ly/bien-ban-giai-the/tao-moi'),
});

onMounted(async () => {
  await fetchBienBanGiaiTheItems();
});

watch(
  () => currentPage.value,
  () => {
    fetchBienBanGiaiTheItems();
  }
);

watch(
  () => perPage.value,
  () => {
    nextTick().then(() => {
      if (currentPage.value === 1) {
        fetchBienBanGiaiTheItems();
        return;
      }
      currentPage.value = 1;
    });
  }
);

watch(
  () => dmToaXeId.value,
  () => {
    nextTick().then(() => {
      if (currentPage.value === 1) {
        fetchBienBanGiaiTheItems();
        return;
      }
      currentPage.value = 1;
    });
  }
);

watch(
  () => loaiBienBan.value,
  () => {
    nextTick().then(() => {
      if (currentPage.value === 1) {
        fetchBienBanGiaiTheItems();
        return;
      }
      currentPage.value = 1;
    });
  },
);

watch(
  () => keHoachSuaChuaId.value,
  () => {
    nextTick().then(() => {
      if (!showFilterByKeHoach.value) {
        return;
      }

      if (currentPage.value === 1) {
        fetchBienBanGiaiTheItems();
        return;
      }

      currentPage.value = 1;
    });
  },
);

watch(searchQuery, debounce(() => {
  nextTick().then(() => {
    if (currentPage.value === 1) {
      fetchBienBanGiaiTheItems();
      return;
    }
    currentPage.value = 1;
  });
}, 700));

const fetchBienBanGiaiTheItems = async () => {
  startLoading();

  try {
    const {
      data: {
        data: { data: res, total },
      },
    } = await BienBanGiaiTheService.list({
      current_page: currentPage.value,
      per_page: perPage.value,
      searchTerm: searchQuery.value,
      ...(dmToaXeId.value && { id_dm_toa_xe: dmToaXeId.value }),
      ...(loaiBienBan.value !== '' && { loai_bien_ban: loaiBienBan.value }),
      ...(showFilterByKeHoach.value && keHoachSuaChuaId.value && { id_khsc: keHoachSuaChuaId.value }),
    });

    totalItems.value = total;
    items.value = res;
    endLoading();
  } catch (e) {
    endLoading();
    swalErrNotification(e, 'Có lỗi xảy ra khi lấy thông tin biên bản');
  }
};

const { safeRefetch } = useSafeRefetch(fetchBienBanGiaiTheItems);

const onHoanThanhHandler = ({ id: bienBanGiaiTheId }: { id: number }) => {
  const foundBienBan = items.value.find(
    ({ id: idBienBan }) => bienBanGiaiTheId === idBienBan
  );

  if (foundBienBan) {
    selectingBienBan.value = foundBienBan;
    confirmHoanThanhBienBan.value = true;
  }
};

const hoanThanhHander = async () => {
  confirmHoanThanhBienBan.value = false;
  await fetchBienBanGiaiTheItems();
};

const onDeleteHandler = ({
  item,
}: {
  id: number;
  item: IBienBanGiaiTheResponseBase;
}) => {
  selectedBienBanForDelete.value = item;
  isConfirmDeleteDialogDisplay.value = true;
};

const confirmDelete = async () => {
  if (!selectedBienBanForDelete.value) return;

  const bienBanToDelete = selectedBienBanForDelete.value;
  isConfirmDeleteDialogDisplay.value = false;
  selectedBienBanForDelete.value = null;

  try {
    await startLoading();

    await BienBanGiaiTheService.delete(bienBanToDelete.id);

    await swalNotification(
      `Xóa biên bản số ${bienBanToDelete.so_bien_ban} thành công`,
      'success'
    );

    await fetchBienBanGiaiTheItems();

    endLoading();
  } catch (e) {
    endLoading();
    await swalErrNotification(e, 'Có lỗi xảy ra khi xóa biên bản');
  }
};

const searchForKeHoach = debounce(async function (query: string) {
  if (!query) {
    dmToaXeId.value = 0;
    return;
  }

  try {
    const {
      data: {
        data: {
          data: options
        }
      }
    } = await KeHoachSuaChuaService.list({
      current_page: 1,
      per_page: 1000,
      s: query,
    });

    keHoachSuaChuaOptions.value = options;
  } catch (e) {
    await swalNotification(
      'Có lỗi xảy ra khi tìm kiếm kế hoạch',
      'error'
    );

    keHoachSuaChuaOptions.value = [];
    keHoachSuaChuaId.value = 0;
  }
}, 500);

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ConfirmationDialog, {
      title: "Xác nhận",
      "is-display": isConfirmDeleteDialogDisplay.value,
      onOnConfirmButtonClick: confirmDelete,
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (isConfirmDeleteDialogDisplay.value = false)),
      onOnCloseIconClick: _cache[1] || (_cache[1] = ($event: any) => (isConfirmDeleteDialogDisplay.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_1, [
          _createTextVNode(" Bạn có chắc chắn muốn xóa biên bản giải thể "),
          _createElementVNode("span", _hoisted_2, _toDisplayString(selectedBienBanForDelete.value?.so_bien_ban), 1),
          _createTextVNode("? ")
        ])
      ]),
      _: 1
    }, 8, ["is-display"]),
    _createVNode(ConfirmHoanThanh, {
      "bien-ban-data": selectingBienBan.value,
      show: confirmHoanThanhBienBan.value,
      onConfirm: hoanThanhHander,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (confirmHoanThanhBienBan.value = false))
    }, null, 8, ["bien-ban-data", "show"]),
    _createVNode(PageContentBase, null, {
      default: _withCtx(() => [
        _createVNode(PageHeaderFilters, null, {
          default: _withCtx(() => [
            _createVNode(FilterItem, { label: "Nhóm toa xe" }, {
              default: _withCtx(() => [
                _createVNode(DanhMucToaXeSearchInput, {
                  "full-width": "",
                  onClear: _cache[3] || (_cache[3] = () => dmToaXeId.value = null),
                  onSelect: _cache[4] || (_cache[4] = ({ id }) => dmToaXeId.value = id)
                })
              ]),
              _: 1
            }),
            _createVNode(FilterItem, { label: "Loại biên bản" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: loaiBienBan.value,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((loaiBienBan).value = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(loaiBienBanOptions, (option) => {
                      return _createVNode(_component_el_option, {
                        key: option.value,
                        label: option.label,
                        value: option.value
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (showFilterByKeHoach.value)
              ? (_openBlock(), _createBlock(FilterItem, {
                  key: 0,
                  label: "Kế hoạch"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: keHoachSuaChuaId.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((keHoachSuaChuaId).value = $event)),
                      clearable: "",
                      filterable: "",
                      "default-first-option": "",
                      "loading-text": "Đang tìm kiếm ...",
                      placeholder: "Nhập để tìm kiếm",
                      remote: "",
                      "remote-method": _unref(searchForKeHoach),
                      onClear: _cache[7] || (_cache[7] = ($event: any) => (keHoachSuaChuaId.value = 0))
                    }, {
                      default: _withCtx(() => [
                        (keHoachSuaChuaOptions.value.length === 0)
                          ? (_openBlock(), _createBlock(_component_el_option, {
                              key: 0,
                              label: "Tất cả kế hoạch",
                              value: 0
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keHoachSuaChuaOptions.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.ten_ke_hoach,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "remote-method"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(BienBanGiaiTheTable, {
          "is-ke-hoach-column-displaying": true,
          items: items.value,
          "is-hoan-thanh-button-displayed": true,
          "show-delete-button": true,
          "on-success": _unref(safeRefetch),
          onOnDetailClick: _cache[8] || (_cache[8] = 
        ({ id }) => _unref(push)(`/quan-ly/bien-ban-giai-the/chi-tiet/${id}`)
      ),
          onOnEditClick: _cache[9] || (_cache[9] = 
        ({ id }) => _unref(push)(`/quan-ly/bien-ban-giai-the/cap-nhat/${id}`)
      ),
          onOnCheckClick: onHoanThanhHandler,
          onOnDeleteClick: onDeleteHandler,
          "cur-page": _unref(currentPage),
          "per-page": _unref(perPage)
        }, null, 8, ["items", "on-success", "cur-page", "per-page"]),
        (items.value.length > 0)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 0,
              page: _unref(currentPage),
              total: _unref(totalItems),
              onChangePage: _cache[10] || (_cache[10] = (value) => (currentPage.value = value)),
              onChangePageSize: _cache[11] || (_cache[11] = (value) => (perPage.value = value))
            }, null, 8, ["page", "total"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})